// nls-rework\src\app\services\payment.service.ts
import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { PaymentForm, RecurringPaymentDetails } from '../models/payment.model';
import { AuthService } from './auth/auth.service';
import { getIpospayDebitUrl, getPaymentsUrl, getRecurringPaymentUrl, getWalletsUrl } from '../shared/utils/api-urls.utils';
import { PaymentDto } from '../models/dtos/payment.dto';

@Injectable({
  providedIn: 'root'
})
export class PaymentService {
  readonly #http = inject(HttpClient);
  private readonly auth = inject(AuthService);

  processPayment(paymentDetails: PaymentForm): Observable<PaymentDto> {
    const token = this.auth.token;
    const headers = new HttpHeaders({ Authorization: `Bearer ${token}` });
    return this.#http.post<PaymentDto>(getPaymentsUrl(), paymentDetails, { headers });
  }

  /**
   * Create a wallet (bank account) for future payments
   */
  createWallet(
    walletData: {
      AccountType: number;        // ← allow 0 or 1 here
      Nickname:    string;
      AccountNumber: string;
      ABANumber:     string;
      Validated:     number;
      Active:        number;
    }
  ): Observable<PaymentDto> {
    const token   = this.auth.token;
    const headers = new HttpHeaders({ Authorization: `Bearer ${token}` });
    return this.#http.post<PaymentDto>(
      getWalletsUrl(),
      walletData,
      { headers },
    );
  }
  
  /**
   * Update an existing recurring payment configuration
   */
  updateRecurringPayment(recurringPaymentId: number, paymentForm: PaymentForm): Observable<PaymentDto> {
    const token = this.auth.token;
    const headers = new HttpHeaders({ Authorization: `Bearer ${token}` });
    return this.#http.put<PaymentDto>(getRecurringPaymentUrl(recurringPaymentId.toString()), paymentForm, { headers });
  }

    updateOneTimePayment(recurringPaymentId: number, paymentForm: PaymentForm): Observable<PaymentDto> {
    const token = this.auth.token;
    const headers = new HttpHeaders({ Authorization: `Bearer ${token}` });
    return this.#http.put<PaymentDto>(getRecurringPaymentUrl(recurringPaymentId.toString()), paymentForm, { headers });
  }

  /**
   * Cancel an existing recurring payment
   */
  cancelRecurringPayment(recurringPaymentId: number): Observable<PaymentDto> {
    return this.#http.delete<PaymentDto>(getRecurringPaymentUrl(recurringPaymentId.toString()));
  }

// payment.service.ts
processDebitCardPayment(req: {
  loanNumber: string;
  amount: number;
  ccNumber: string;   // digits only
  ccExpiry: string;   // MMYY, e.g. "1228"
  ccCvv: string;      // 3–4 digits
  zip: string;        // 5 digits
}): Observable<any> {
  const token = this.auth.token;
  const headers = new HttpHeaders({ Authorization: `Bearer ${token}` });

  // use your URL helper
  // (make sure you have getIpospayDebitUrl() defined)
  return this.#http.post<any>(getIpospayDebitUrl(), req, { headers });
}


  /**
   * Get details of an existing recurring payment for editing
   */
  getRecurringPaymentDetails(recurringPaymentId: number): Observable<RecurringPaymentDetails> {
    return this.#http.get<RecurringPaymentDetails>(getRecurringPaymentUrl(recurringPaymentId.toString()));
  }

    /**
   * Get details of an existing one-time payment for editing
   */
  getPendingPaymentById(recurringPaymentId: number): Observable<RecurringPaymentDetails> {
    return this.#http.get<RecurringPaymentDetails>(getRecurringPaymentUrl(recurringPaymentId.toString()));
  }
}
